import { TimeInput } from "@msuite/ui/date-input";
import { Divider } from "@msuite/ui/divider";
import { NumberInput, TextInput } from "@msuite/ui/form";
import { useTranslation } from "@msuite/ui/localization";
import { WeekdayPicker } from "@msuite/ui/weekday-picker";
import { moment } from "@msuite/utils/date";
import type { TourWaveFormSchema } from "@msuite/utils/schemas";
import { calculateTourWaveCutoffTime } from "@msuite/utils/stock";
import { useFormContext, useWatch } from "react-hook-form";

export function TourWaveForm() {
	/** Context */
	const methods = useFormContext<TourWaveFormSchema>();
	const [startTime, cutoffOffset] = useWatch({
		control: methods.control,
		name: ["startTime", "cutoffOffset"],
	});

	/** Hooks */
	const { t } = useTranslation();

	return (
		<div className="v-stack gap-4">
			<TextInput
				isRequired
				label={t("stock.tour_wave")}
				control={methods.control}
				name="name"
				placeholder={t("placeholders.stock.tour_name")}
			/>
			<div className="grid grid-cols-2 gap-x-4">
				<TimeInput
					label={t("dates.start_time")}
					control={methods.control}
					name="startTime"
				/>
				<TimeInput
					label={t("dates.end_time")}
					control={methods.control}
					name="endTime"
				/>
			</div>
			<WeekdayPicker
				control={methods.control}
				name="weekdays"
			/>
			<Divider />
			<NumberInput
				label={t("stock.cutoff_offset")}
				isRequired
				min={0}
				control={methods.control}
				name="cutoffOffset"
				placeholder="0"
				step={0.5}
				helperText={t("stock.cutoff_time_helper_text", {
					weekday: moment().format("dddd"),
					cutoffDate: calculateTourWaveCutoffTime(moment().setTime(startTime), cutoffOffset).format(
						"dddd, HH:mm",
					),
				})}
				variant="hour"
				defaultValue={0}
			/>
		</div>
	);
}
